import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {TeamCompanyUsersService} from '../../services/teamcompanyusers/teamcompanyusers.service';
import {UsersService} from '../../services/users/users.service';
import {MatSort} from '@angular/material/sort';

interface TeamCompanyUser {
  company: string;
  role: string;
  createdAt: string;
  name: string;
}

@Component({
  selector: 'app-products-permissions',
  templateUrl: './products-permissions.component.html',
  styleUrls: ['./products-permissions.component.scss']
})
export class ProductsPermissionsComponent implements OnInit {

  // @ts-ignore
  @ViewChild(MatSort) sort: MatSort;

  public permissions = new MatTableDataSource<TeamCompanyUser>();

  public columnsToDisplay = ['companyName', 'role', 'createdAt', 'name', 'grantorName'];

  constructor(
      private teamCompanyUsersService: TeamCompanyUsersService,
      private usersService: UsersService
  ) { }

  ngOnInit(): void {
    this.teamCompanyUsersService.getAllCompanyUsers().then(result => {
      this.permissions.data = result;
      this.permissions.sort = this.sort;
    });
  }

}
